<template>
  <div>
    <BaseListPage
        id="extraExport"
        ref="listPage"
        :name="name"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :show-selection="showSelection"
        :row-key="rowKey"
        :span-method="spanMethod"
        :can-select-method="canSelectMethod"
        :cell-style="cellStyle"
        title="臨時出荷指図依頼一覧"
        title-class="order-header"
        icon="order"
        table-class="orderlist-table-list row-clickable-table"
        :is-limit-check="false"
        @searched="onSearched"
        @row-click="onRowClick">
      <span
          slot="headerAction"
          class="action_button">
        <el-button v-if="$isFunctionShown(define.PermissionKeys.Order.ExtraExportRequestList.EXPORT_REQUEST)"
            :disabled="$isFunctionDisabled(define.PermissionKeys.Order.ExtraExportRequestList.EXPORT_REQUEST) || selectQty === 0"
            @click="extraExport">
          実行
        </el-button>
      </span>
      <template
          slot="prefixTable">
        <div class="prefixTableRow">
          <span>
            {{
              `対象配送件数： ${selectQty} 件`
            }}
          </span>
        </div>
      </template>
    </BaseListPage>
    <BaseDialog
        title="注文情報"
        width="70%"
        class="orderDetailDialog"
        :show-only-close-button="true"
        :visible.sync="orderDetailDialogVisible">
      <template slot="contents">
        <!-- 配送先情報 -->
        <el-row>
          <el-col :span="12">
            <BaseTableDetail
                class="shipment-item"
                :table-set-list="shipmentInfo1"
                :display-item="orderDetailData"
                :site-code="orderSiteCode()" />
          </el-col>
          <el-col :span="12">
            <BaseTableDetail
                class="shipment-item"
                :table-set-list="shipmentInfo2"
                :display-item="orderDetailData"
                :site-code="orderSiteCode()" />
          </el-col>
        </el-row>

        <!-- 商品明細 -->
        <BaseTableList
            ref="tableList"
            class="shipment-item-row"
            :table-set-list="itemRowColumns"
            :display-items="orderDetailData.items || []" />
      </template>
    </BaseDialog>
    <BaseDialog
        title="臨時出荷指図依頼"
        width="800px"
        class="resultDialog"
        :show-only-close-button="true"
        :visible.sync="resultDialogVisible">
      <template slot="contents">
        <div v-if="resultData"
            class="resultContents">
          <div class="success">
            {{ `${resultData.requestCount}件中、${resultData.succeeded.count}件が臨時出荷指図処理されました。` }}
          </div>
          <div v-if="(resultData.failed || []).count > 0"
              class="failed">
            <div>
              {{ `失敗(${resultData.failed.count}件)` }}
            </div>
            <template v-for="(error, index) in resultData.failed.errors">
              <div :key="index">
                <div class="reason">
                  {{ `理由：${resultMessage(error.reason)}` }}
                </div>
                <div class="shipmentIds">
                  {{ `  ${error.shipments.map((shipment) => shipment.shipmentId)}` }}
                </div>
              </div>
            </template>
          </div>
          <div v-if="(resultData.isSync == null ? 1 : resultData.isSync) === 0"
              class="note">
            一覧の反映に失敗しました。<br>
            最新の注文情報が反映されるまで、時間がかかる可能性があります。<br>
            しばらく待ってから処理結果を確認してください。
          </div>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>

.resultDialog .resultContents {
  padding: 10px;
  color: #181d61;
  font-size: 16px;
}

.resultDialog .resultContents .success {
  padding: 10px;
}

.resultDialog .resultContents .failed {
  padding: 10px;
  padding-top: 20px;
}

.resultDialog .resultContents .note {
  padding: 10px;
  padding-top: 20px;
  color: red;
}

.resultDialog .resultContents .reason {
  padding-left: 40px;
}

.resultDialog .resultContents .shipmentIds {
  padding-left: 60px;
}

#extraExport ::v-deep .el-table__header .qty .cell {
  white-space: pre-line!important;
}

#extraExport ::v-deep .el-table__row .itemHtml {
  padding: 0!important;

}
#extraExport ::v-deep .el-table__row .itemHtml > .cell {
  padding: 0!important;
}
#extraExport ::v-deep table {
  border-collapse:collapse
}

#extraExport ::v-deep tr {
  border-bottom: solid 1px #dddddd;
  border-left: solid 1px #dddddd;
  border-right: solid 1px #dddddd;
}

#extraExport ::v-deep .el-table__row .innerTable {
  width: 100%;
}

#extraExport ::v-deep .el-table__row .innerTable tr {
  background-color: initial;
}

#extraExport ::v-deep .el-table__row .innerTable tr:last-child {
  border-bottom: none;
}

#extraExport ::v-deep .el-table__row .innerTable td {
  padding-left: 10px;
  padding-right: 10px;
}

#extraExport ::v-deep .el-table__row .innerTable .tag .el-tag {
  min-width: 48%;
  text-align: center;
}

.shipment-item ::v-deep th,
.shipment-item ::v-deep td {
    padding: 5px 15px;
    font-size: 14px;
    text-align: left;
    vertical-align: top;
}

.shipment-item ::v-deep th {
    width: 230px;
    padding-right: 0;
}

.shipment-item-row ::v-deep .el-table__body-wrapper {
    max-height: 300px;
    overflow-y: auto;
}

</style>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as config from '@/config'
import * as define from '@/define'
import * as query from '@/queries/order'
import message from '@/utils/message'
import common from '@/utils/common'

import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'
import moment from 'moment'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'
import BaseDialog from '@/components/molecules/BaseDialog'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import BaseTableList from '@/components/molecules/BaseTableList'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'

const RESULT_MESSAGE_MAPPING = Object.freeze({
  'not created orderExport': '出荷指図作成の対象になりませんでした。',
  'orderExport processor not found': '出荷指図連携処理が見つかりませんでした。',
  'not exported orderExport': '出荷指図連携の対象になりませんでした。\r\n出荷指図が連携されているかご確認ください。'
})

export default {
  name: 'OrderList',
  components: {
    BaseListPage,
    BaseDialog,
    BaseTableDetail,
    BaseTableList
  },
  mixins: [ x, orderUtil, confirmDiscardOnLeave ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      orderDetailDialogVisible: false,
      orderDetailData: {},
      resultData: null,
      resultDialogVisible: false,
      selectQty: 0
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      tableSetList: (state) => state.ExtraExport.tableSetList || false,
      searchKeyword: (state) => state.ExtraExport.searchKeyword || '',
      tdLists: (state) => state.ExtraExport.tdLists || [],
      isAndSearch: (state) => state.ExtraExport.isAndSearch || false,
      searchConditions: (state) => state.ExtraExport.searchConditions || {},
      timeZone: (state) => state.timeZone || 'Asia/Tokyo',
      size: (state) => state.size || 0,
      listIndex: (state) => state.listIndex || 10
    }),
    ...mapGetters({
      searchConditions: 'searchConditions',
      allowPartialShipment: 'allowPartialShipment',
      isScheduledShippingAt: 'isScheduledShippingAt',
      customCellStyle: 'customCellStyle'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'extraExportList'
    },
    storePath () {
      return 'ExtraExport'
    },
    saveKey () {
      return 'extraExportCondition'
    },
    responsePath () {
      return 'data.latestOrders.edges'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_EXTRA_EXPORT_LIST
    },
    sortedList () {
      const data = this.convertOrderData(this.tdLists)
      const sort = this.sortCondition(this.name)
      if (sort.order == null) {
        return data
      } else {
        return common.sortListData(data, sort)
      }
    },
    showSelection () {
      return true;
    },
    rowKey () {
      return 'orderNoShipmentId'
    },
    _tableSetList () {
      return [
        { type: 'String', label: '注文番号', path: 'orderNo', sortable: 'custom', width: 200 },
        { type: 'String', label: '配送番号', path: 'shipmentId', sortable: 'custom', width: 200 },
        { type: 'String', label: 'SKU', path: 'itemHtml', class: 'itemHtml', elementType: ELEMENT_TYPE.HTML, width: 270 },
        { type: 'String', label: '商品名', path: 'lineitemText' },
        { type: 'String', label: 'ステータス', path: 'status', class: 'center', size: 'small', width: 250 },
        { type: 'Number', label: '数量', width: 60, class: 'right qty', path: 'qty.current' },
        { type: 'Number', label: '指図　\n待ち数', width: 70, class: 'right qty', path: 'qty.preExport' },
        { type: 'Number', label: '再送信　\n指図待ち', width: 80, class: 'right qty', path: 'qty.preReExport' },
        { type: 'Number', label: '交換出荷　\n(指図待ち)', width: 100, class: 'right qty', path: 'qty.exOut' }
      ]
    },
    shipmentInfo1 () {
      return [
        {
          label: '配送番号',
          properties: [ {
            path: 'shipmentId', type: 'String',
            funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.NUMBER
          } ],
          horizontal: true
        },
        {
          label: '配送先氏名',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.CELL,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_NAME,
              horizontal: true,
              properties: [
                {
                  path: 'receiver.lastName', type: 'String'
                }, {
                  path: 'receiver.firstName', type: 'String'
                }
              ]
            }
          ]
        },
        {
          label: '配送先TEL',
          properties: [
            {
              path: 'receiver.phone', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_TEL
            }
          ],
          horizontal: true
        },
        {
          label: '〒',
          properties: [
            {
              path: 'address.postalCode', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_POSTAL_CODE
            }
          ]
        },
        {
          label: '都道府県',
          properties: [
            {
              path: 'address.stateCode', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_STATE
            }
          ]
        },
        {
          label: '市区町村',
          properties: [
            {
              path: 'address.city', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_CITY
            }
          ]
        },
        {
          label: '住所1',
          properties: [
            {
              path: 'address.address1', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_ADDRESS_1
            }
          ]
        },
        {
          label: '住所2',
          properties: [
            {
              path: 'address.address2', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_ADDRESS_2
            }
          ]
        },
        {
          label: '建物名・部屋番号',
          properties: [
            {
              path: 'address.suite', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.RECIPIENT_SUITE
            }
          ]
        }
      ]
    },
    shipmentInfo2 () {
      return [
        {
          label: '配送方法',
          properties: [
            {
              path: 'shippingMethod', type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX,
              codeName: 'd_order_shipment.shipping_method',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.SHIPPING_METHOD
            }
          ]
        },
        {
          label: 'ギフトタイプ',
          properties: [
            {
              path: 'giftType', type: 'Number', elementType: ELEMENT_TYPE.SELECT_BOX,
              codeName: 'd_order_shipment.gift_type',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.GIFT_TYPE
            }
          ]
        },
        {
          label: 'ギフトメッセージ',
          properties: [
            {
              path: 'giftMessage', type: 'String',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.GIFT_MESSAGE
            }
          ]
        },
        {
          label: '配達希望日',
          properties: [
            {
              path: 'deliveryDate', type: 'Date', dateFormat: 'YYYY/MM/DD', dateOnly: true,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.DELIVERY_DATE
            }
          ]
        },
        {
          label: '配達希望時間帯',
          properties: [
            {
              path: 'deliveryTime', type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX,
              codeName: 'd_order_shipment.delivery_time', funcId: define.PermissionKeys.Order.Detail.OrderInfo.ShipmentInfo.DELIVERY_TIME
            }
          ]
        }
      ]
    },
    itemRowColumns () {
      return [
        { label: 'No', type: 'String', path: 'position', class: 'right', width: 60 },
        { label: 'SKU', type: 'String', path: 'productId', width: 250 },
        { label: '商品名', type: 'String', path: 'lineitemText' },
        { label: '売価', type: 'Number', path: 'basePrice.gross', class: 'right', width: 100 },
        { label: '数量', type: 'Number', path: 'qty.current', class: 'right', width: 80 },
        { label: '金額', type: 'Number', path: 'price.gross', class: 'right', width: 100 }
      ]
    }
  },
  beforeRouteLeave (to, from, next) {
    // 別ページへ移動する場合、storeの一覧情報を削除する
    this.$store.dispatch({
      type: 'set',
      states: {
        'ExtraExport/tdLists': []
      }
    })

    next()
  },
  created () {
    this.$store.dispatch({
      type: 'set',
      states: {
        'ExtraExport/tableSetList': this._tableSetList
      }
    })
    // 子componentの生成が完了していないため、時間差でwatchを登録する
    setTimeout(() => this.$watch('$refs.listPage.$refs.tableList.$refs.table.selection.length', () => this.calcSelectQty(), { deep: true }), 1)
  },
  methods: {
    extraExport () {
      this.$confirm('臨時出荷指図を依頼しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()

          // // 臨時出荷指図依頼APIの呼び出し
          const url = config.ORDER_EXTRA_EXPORT_URL
          const method = 'post'
          const response = await common.apiAxios(url, {
            method,
            data: {
              shipments:
                _.get(this.$refs, 'listPage.$refs.tableList.$refs.table.selection', []).map((row) => {
                  return {
                    uuid: row.uuid
                  }
                })
            }
          })
          this.resultData = _.get(response, 'data', {})
          this.resultData.requestCount = this.selectQty

          // 対象の再検索
          const query = common.addGraphQlCondition(this.baseQuery,
            { orderNos: _.get(this.$refs, 'listPage.$refs.tableList.$refs.table.selection', []).map((row) => row.orderNo) })
          const res = await common.postGraphQl(query, { isMessageControl: true })
          const data = this.dataConvert(_.get(res, 'data.data.latestOrders.edges', []))

          const newTdLists = _.cloneDeep(this.tdLists)
          data.forEach((newData) => {
            let oldDataIndex = newTdLists.findIndex((oldData) => oldData.orderNo === newData.orderNo &&
              oldData.shipmentId === newData.shipmentId)
            if (oldDataIndex >= 0) newTdLists.splice(oldDataIndex, 1, newData)
          })

          this.$store.dispatch({
            type: 'set',
            states: {
              'ExtraExport/tdLists': newTdLists
            }
          })

          this.resultDialogVisible = true

          const tableData = _.get(this.$refs, 'listPage.$refs.tableList.$refs.table', {})
          tableData.clearSelection()
        } catch (error) {
          common.addError(error, { msg: message.MSG_540() })
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {})
    },
    /**
     * 注文ステータスを返却します。
     * @param {Object} row 注文情報
     * @returns {Array} tag 生成のための配列
     */
    orderItemStatus: function (row) {
      return this.$_orderUtil_orderStatusTag(row)
    },
    onRowClick (row, column, event) {
      // 詳細表示
      this.orderDetailDialogVisible = true
      this.orderDetailData = row
    },
    orderSiteCode () {
      return _.get(this.orderDetailData, 'site.code', '')
    },
    resultMessage (responseMessage) {
      return _.get(RESULT_MESSAGE_MAPPING, responseMessage, '')
    },
    calcSelectQty () {
      this.selectQty = _.get(this.$refs, 'listPage.$refs.tableList.$refs.table.selection.length', 0)
    },
    spanMethod ({ row, column, rowIndex, columnIndex }) {
      if (['itemHtml'].includes(column.property)) {
        return {
          rowspan: 1,
          colspan: 7
        }
      } else if (['lineitemText', 'status', 'qty.current', 'qty.preExport', 'qty.preReExport', 'qty.exOut'].includes(column.property)) {
        // SKU項目で全項目分のhtmlを記載するため不要
        return {
          rowspan: 1,
          colspan: 1
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        }
      }
    },
    onSearched (result) {
      // 最大表示件数は100件とする
      const maxListSize = 100

      // 配送単位に加工する
      // 値無しプロパティであった場合、スキップするような作りにする
      // 配送単位で100件にする。処理を改善するため注文単位の100件を処理に渡す
      const data = this.dataConvert(_.get(result, 'data.latestOrders.edges', []).slice(0, maxListSize)).slice(0, maxListSize)
      const totalCount = this.getShipmentsQty(_.get(result, 'data.latestOrders.edges', []))
      // itemHtmlは保持しないので削除
      this.$store.dispatch({
        type: 'set',
        states: {
          'ExtraExport/tdLists': data,
          'ExtraExport/totalCount': totalCount
        }
      })

      if (maxListSize < totalCount && totalCount !== 0) {
        // 検索結果の件数が上限を超えた場合
        this.$notify.warning(message.MSG_305({ limit: maxListSize, count: totalCount }))
      }

      // 選択の全解除
      _.get(this.$refs, 'listPage.$refs.tableList.$refs.table', {}).clearSelection()
      this.calcSelectQty()
    },
    // 配送単位のデータへ変更
    dataConvert: function (orders) {
      const data = []
      orders.forEach((orderNode) => {
        const order = _.get(orderNode, 'node', {})
        const cloneOrder = _.cloneDeep(order)
        delete cloneOrder.shipments
        _.get(order, 'shipments', []).forEach((shipment) => {
          const newData = Object.assign({}, cloneOrder, shipment)
          newData[this.rowKey] = cloneOrder.orderNo + shipment.shipmentId
          this.calcCanSelect(newData)
          data.push(newData)
        })
      })
      return data
    },
    // 配送単位のデータ数を取得
    getShipmentsQty: function (orders) {
      let qty = 0
      orders.forEach((orderNode) => {
        const order = _.get(orderNode, 'node', {})
        qty += order.shipments.length
      })
      return qty
    },
    convertOrderData: function (orders) {
      const data = []
      orders.forEach((order) => {
        let itemHtml = ` <table class='innerTable'> `
        _.get(order, 'items', []).forEach((item) => {
          let statusHtml = ``
          for (const status of this.orderItemStatus(item)) {
            statusHtml += `
              <span class="el-tag el-tag--small ${status.class}">
                ${status.label}
              </span>
            `
          }

          itemHtml += `
              <tr>
                <td style='width:270px;'>${item.productId}</td>
                <td>${item.lineitemText}</td>
                <td class='center tag' style='width:250px;'>${statusHtml}</td>
                <td class='right' style='width:60px;'>${Vue.filter('formatter')(item.qty.current, 'Number')}</td>
                <td class='right' style='width:70px;'>${Vue.filter('formatter')(item.qty.preExport, 'Number')}</td>
                <td class='right' style='width:80px;'>${Vue.filter('formatter')(item.qty.preReExport, 'Number')}</td>
                <td class='right' style='width:100px;'>${Vue.filter('formatter')(item.qty.exOut, 'Number')}</td>
              </tr>
          `
        })
        itemHtml += ' </table> '
        const newData = Object.assign({}, { itemHtml }, order)
        this.calcCanSelect(newData)
        data.push(newData)
      })

      return data
    },
    canSelectMethod: function (row, index) {
      return row.canSelect
    },
    calcCanSelect: function (row) {
      row.canSelect = false
      // [ 指図待ち > 0 or 再送指図待ち > 0 or 交換出荷(指図待ち) > 0 ] の明細が存在する事
      if (row.items.filter((item) => item.isShipment === 1)
        .some((item) => (this.$_orderUtil_preExport(item.qty) > 0 ||
          this.$_orderUtil_preReExport(item.qty) > 0) ||
          (this.$_orderUtil_exOut(item.qty) > 0))) {
        if (this.isScheduledShippingAt(row.site.code)) {
          // 出荷予定日日時連携設定の値1 が 1の場合
          if (!row.items.filter((item) => item.isShipment === 1)
            .some((item) => {
              // 当該明細の 発売日 が NULL ではない事
              return item.releaseDatetime != null &&
                // 当該明細の 出荷指示送信開始日 が 未来日 ではない
                moment(item.preparingShipmentStartedAt || 0) <= moment() &&
                // [ 指図待ち > 0 or 再送指図待ち > 0 or 交換出荷(指図待ち) > 0] の明細が存在する
                ((this.$_orderUtil_preExport(item.qty) > 0) ||
                (this.$_orderUtil_preReExport(item.qty) > 0) ||
                (this.$_orderUtil_exOut(item.qty) > 0))
            })) {
            // NGであれば選択不可
            return
          }
        }
        // 分割許可設定の値1が 0(分割許可しない) の場合
        // [ 指図待ち > 0 or 再送指図待ち > 0 ] の明細が存在し、分割許可設定の値1が 0(分割許可しない) の場合
        if (this.allowPartialShipment(row.site.code) === '0' &&
          row.items.filter((item) => item.isShipment === 1)
            .some((item) => (this.$_orderUtil_preExport(item.qty) > 0 ||
              this.$_orderUtil_preReExport(item.qty) > 0))) {
          if (row.items.filter((item) => item.isShipment === 1)
            .filter((item) => this.$_orderUtil_preExport(item.qty) > 0 ||
                this.$_orderUtil_preReExport(item.qty) > 0 ||
                this.$_orderUtil_exOut(item.qty) > 0)
            .every((item) => {
              // 全ての明細が
              // [ 未引当 = 0 and 処理待ち = 0 and 出荷不可 = 0 ] である事
              // 出荷予定日日時連携設定の値1 が 1の場合(0の場合はOK)
              //   当該明細の 発売日 が NULL ではない事
              //   当該明細の 出荷指示送信開始日 が 未来日 ではない
              return this.$_orderUtil_unallocated(item.qty) === 0 &&
                this.$_orderUtil_pending(item.qty) === 0 &&
                this.$_orderUtil_unshipped(item.qty) === 0 &&
                (!this.isScheduledShippingAt(row.site.code) ||
                  (
                    item.releaseDatetime != null &&
                    moment(item.preparingShipmentStartedAt || 0) <= moment()
                  )
                )
            })) {
            row.canSelect = true
          }
        } else {
          // 分割許可設定の値1が 1(分割許可する) の場合
          row.canSelect = true
        }
      }
    },
    cellStyle (r) {
      return this.$_mixin_cellStyle(r, this.customCellStyle('extra_export_list'))
    }
  }
}
</script>
